import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntuitiveToothForDiagram } from '../../models/intuitive-tooth-for-diagram';
import { RxIntuitiveToothComponent } from '../rx-intuitive-tooth/rx-intuitive-tooth.component';

/**
 * Displays a horizontal list of teeth in a compact format.
 * Used in modals to show selected teeth.
 */
@Component({
	selector: 'rx-intuitive-mini-teeth-diagram',
	templateUrl: './rx-intuitive-mini-teeth-diagram.component.html',
	styleUrls: ['./rx-intuitive-mini-teeth-diagram.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, RxIntuitiveToothComponent]
})
export class RxIntuitiveMiniTeethDiagramComponent {
	@Input() teeth: IntuitiveToothForDiagram[] = [];
	@Input() numberPosition: 'above' | 'below' = 'below';

	trackByToothId(_index: number, tooth: IntuitiveToothForDiagram): number {
		return tooth.toothId;
	}
}
